/* =========================================================
   Maison · Menú a pantalla completa (sections/maison-menu.liquid)
   Reemplaza el menú lateral del theme: el ícono de menú del header lo abre.
   ========================================================= */
(function () {
  'use strict';

  if (customElements.get('maison-menu')) return;

  var CLOSE_MS = 850;
  var root = document.documentElement;

  class MaisonMenu extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.mm__panel');
      this.current = 'root';
      this.lastTrigger = null;
      this.closedByKey = false;
      this.abort = new AbortController();
      var signal = this.abort.signal;

      this.addEventListener('click', this.onClick.bind(this), { signal: signal });
      this.addEventListener('pointerover', this.onPointerOver.bind(this), { signal: signal });
      document.addEventListener('keydown', this.onKeydown.bind(this), { signal: signal });

      // Enlaces que abren el menú directo en un nivel (ej.: "Marcas" en los accesos rápidos)
      document.addEventListener('click', (e) => {
        var go = e.target.closest && e.target.closest('[data-mm-go]');
        if (!go || this.contains(go)) return;
        e.preventDefault();
        this.open(go);
        this.setLevel(go.dataset.mmGo, true);
      }, { signal: signal });

      // El ícono de menú del header abre este menú en lugar del lateral del theme
      document.addEventListener('click', (e) => {
        var trigger = e.target.closest && e.target.closest('#header-component .header__icon--menu, #header-component .menu-drawer-container > summary');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        this.resetTheme();
        this.open(trigger);
        setTimeout(this.resetTheme, 50);
      }, { capture: true, signal: signal });

      window.addEventListener('pageshow', () => {
        this.classList.remove('is-open');
        this.hidden = true;
        root.classList.remove('mm-locked');
        this.resetTheme();
      }, { signal: signal });
    }

    disconnectedCallback() {
      this.abort.abort();
      root.classList.remove('mm-locked');
    }

    // El ícono del theme (hamburguesa / cruz) vuelve a su estado original
    resetTheme() {
      document.querySelectorAll('#header-component .menu-drawer-container').forEach(function (d) {
        d.classList.remove('menu-open');
        d.open = false;
      });
    }

    open(trigger) {
      clearTimeout(this.closeTimer);
      this.lastTrigger = trigger || null;
      this.setLevel('root', true);
      this.hidden = false;
      root.classList.add('mm-locked');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-open'));
      });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setTimeout(() => {
        var closeBtn = this.querySelector('.mm__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }, 60);
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      root.classList.remove('mm-locked');
      this.resetTheme();
      if (this.lastTrigger) {
        this.lastTrigger.setAttribute('aria-expanded', 'false');
        if (this.closedByKey) this.lastTrigger.focus({ preventScroll: true });
        else if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();
      }
      this.closedByKey = false;
      this.closeTimer = setTimeout(() => { this.hidden = true; }, CLOSE_MS);
    }

    showGrid(id) {
      var target = this.querySelector('[data-mm-grid="' + id + '"]') || this.querySelector('[data-mm-grid="root"]');
      this.querySelectorAll('[data-mm-grid]').forEach(function (g) { if (g !== target) g.classList.remove('is-active'); });
      if (target && !target.classList.contains('is-active')) {
        void target.offsetWidth; // reinicia la animación de las imágenes
        target.classList.add('is-active');
        var media = this.querySelector('.mm__media');
        if (media) media.scrollTop = 0;
      }
    }

    setLevel(id, instant) {
      var next = this.querySelector('[data-mm-level="' + id + '"]');
      var prev = this.querySelector('.mm__level.is-active');
      if (!next) return;
      this.querySelectorAll('[data-mm-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.dataset.mmOpen === id ? 'true' : 'false');
      });
      if (prev === next) { this.showGrid(id); return; }
      var enter = () => {
        if (prev) { prev.classList.remove('is-active', 'is-leaving'); prev.hidden = true; }
        next.hidden = false;
        void next.offsetWidth;
        next.classList.add('is-active');
        this.current = id;
        this.showGrid(id);
        var focusable = next.querySelector('.mm__back, .mm__link');
        if (focusable && !instant) focusable.focus({ preventScroll: true });
      };
      if (prev && !instant && this.classList.contains('is-open')) {
        prev.classList.add('is-leaving');
        setTimeout(enter, 280);
      } else {
        enter();
      }
    }

    onClick(e) {
      var t = e.target;
      if (t.closest('[data-mm-close]')) { this.close(); return; }
      var opener = t.closest('[data-mm-open]');
      if (opener) { this.setLevel(opener.dataset.mmOpen); return; }
      var back = t.closest('[data-mm-back]');
      if (back) { this.setLevel(back.dataset.mmBack || 'root'); return; }
      if (t.closest('a[href]')) {
        // se cierra suave antes de navegar
        this.classList.remove('is-open');
        root.classList.remove('mm-locked');
        this.resetTheme();
      }
    }

    // En desktop, pasar por un ítem con subnivel muestra su grilla (vista previa)
    onPointerOver(e) {
      if (e.pointerType !== 'mouse' || this.current !== 'root') return;
      var opener = e.target.closest('[data-mm-open]');
      if (opener) this.showGrid(opener.dataset.mmOpen);
      else if (e.target.closest('[data-mm-preview]')) this.showGrid('root');
    }

    onKeydown(e) {
      if (this.hidden) return;
      if (e.key === 'Escape') {
        if (this.current !== 'root') this.setLevel('root');
        else { this.closedByKey = true; this.close(); }
      }
      if (e.key === 'Tab' && this.panel) {
        // el foco queda dentro del panel
        var items = Array.prototype.filter.call(
          this.panel.querySelectorAll('a[href], button:not([disabled])'),
          function (el) { return el.offsetParent !== null; }
        );
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  customElements.define('maison-menu', MaisonMenu);
})();
